(function() {
  function addSoldOutBadges() {
    var allButtons = document.querySelectorAll('button, [type="submit"], .btn, .button, input[type="submit"]');
    allButtons.forEach(function(btn) {
      var text = (btn.textContent || btn.value || '').trim().toLowerCase();
      if (btn.disabled || text === 'sold out' || text === 'unavailable' || text.includes('sold out')) {
        var card = btn.closest('li, article, .product-item, .product_item, .product-card, .grid-item, [class*="product-item"], [class*="product_item"]');
        if (card) {
          var imgWrapper = card.querySelector('a');
          if (imgWrapper) {
            var pos = window.getComputedStyle(imgWrapper).position;
            if (pos === 'static') { imgWrapper.style.position = 'relative'; }
            if (!imgWrapper.querySelector('.blklst-sold-out-badge')) {
              var badge = document.createElement('div');
              badge.className = 'blklst-sold-out-badge';
              badge.textContent = 'SOLD OUT';
              imgWrapper.appendChild(badge);
            }
          }
        }
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addSoldOutBadges);
  } else {
    addSoldOutBadges();
  }
})();